import { Price } from 'swag-client-common/utils/price';
import { getTotalCount } from 'swag-client-common/utils/product.utils';
import { getAvailableQuantities } from '../../../../../redux/box-builder/box-builder.selectors';
export function getFooterPrices(currentBoxesQuantity, productCardItems, addonCardItems, currentSpecialBoxProduct, otherSpecialBoxProductsSelector) {
  const boxPrice = currentSpecialBoxProduct ? Price.getBoxPrice({
    orderItem: {
      quantity: currentBoxesQuantity
    },
    product: currentSpecialBoxProduct,
    isBoxItemsPriceAdded: false
  }) : 0;
  const selectedItemsSetupFee = [...productCardItems, ...addonCardItems].reduce((acc, cardItem) => {
    if (cardItem.isSelected && cardItem.quantityPerBox > 0) {
      var _acc$cardItem$asRelat;
      const relatedTotalCountOfItems = productCardItems.reduce((result, otherCardItem) => {
        if (otherCardItem.asRelatedItemId !== cardItem.asRelatedItemId) {
          return result;
        }
        const totalQuantityInThisBox = otherCardItem.quantitiesInThisBox ? getTotalCount(otherCardItem.quantitiesInThisBox) : 0;
        const totalCountOfItems = totalQuantityInThisBox + getTotalCount(otherCardItem.cartQuantities);
        return result + totalCountOfItems;
      }, 0);
      if (!relatedTotalCountOfItems) {
        return acc;
      }
      const screenPrice = Price.getScreenPriceForRelatedProduct(cardItem.setupFee, relatedTotalCountOfItems);
      acc[cardItem.asRelatedItemId] = {
        setupFeeToCalculateTotal: screenPrice * cardItem.totalCount + ((acc === null || acc === void 0 ? void 0 : (_acc$cardItem$asRelat = acc[cardItem.asRelatedItemId]) === null || _acc$cardItem$asRelat === void 0 ? void 0 : _acc$cardItem$asRelat.setupFeeToCalculateTotal) || 0),
        sharedSetupFee: cardItem.setupFee
      };
    }
    return acc;
  }, {});
  const {
    totalSharedSetupFee,
    totalSetupFeeToCalculateTotal
  } = Object.values(selectedItemsSetupFee).reduce((acc, {
    sharedSetupFee,
    setupFeeToCalculateTotal
  }) => {
    if (currentBoxesQuantity === 0) {
      return acc;
    }
    acc.totalSharedSetupFee += sharedSetupFee;
    acc.totalSetupFeeToCalculateTotal += setupFeeToCalculateTotal;
    return acc;
  }, {
    totalSharedSetupFee: 0,
    totalSetupFeeToCalculateTotal: 0
  });
  const totalForSelectedProducts = [...productCardItems, ...addonCardItems].reduce((acc, cardItem) => {
    if (!cardItem.isSelected || cardItem.quantityPerBox === 0) {
      return acc;
    }
    const availableQuantities = getAvailableQuantities({
      quantitiesInCart: cardItem.cartQuantities,
      quantitiesInThisBox: cardItem.quantitiesInThisBox
    });
    const totalSelectedQuantity = cardItem.totalCount;
    const totalAvailableQuantity = getTotalCount(availableQuantities);
    const quantityToUse = Math.min(totalSelectedQuantity, totalAvailableQuantity);
    return acc + quantityToUse * cardItem.itemPriceValue;
  }, 0);
  const totalForOtherSpecialBoxProducts = otherSpecialBoxProductsSelector.reduce((acc, item) => {
    const pricePerItem = Math.round(item.price / item.quantity);
    return acc + currentBoxesQuantity * pricePerItem;
  }, 0);
  const totalForAllBoxes = totalForSelectedProducts + boxPrice + totalSetupFeeToCalculateTotal + totalForOtherSpecialBoxProducts;
  const pricePerBox = Math.round((totalForAllBoxes - totalSetupFeeToCalculateTotal) / currentBoxesQuantity);
  return {
    pricePerBox: isFinite(pricePerBox) ? pricePerBox : 0,
    setupFee: totalSharedSetupFee,
    total: totalForAllBoxes
  };
}